import type { Product } from '~/api/products/types';

import { ProductStatusTag } from '~/features/products';

type Props = {
  status: Product['status'];
};

export const ProductStatusCell = ({ status }: Props) => {
  return <ProductStatusTag status={status} />;
};
